@if (runData) {
    <adapt-team-display-configuration [entity]="team"
                                      [disabled]="submitting"
                                      (configureOrganisationGroupTypesClicked)="onConfigureOrganisationGroupTypesClicked()"
                                      (teamTypeConfigurationChanged)="onTeamTypeConfigurationChange($event)"></adapt-team-display-configuration>
}

<ng-template #createTeamButton>
    <adapt-add-team-create-team-button [instance]="this"></adapt-add-team-create-team-button>
</ng-template>
